<template>
  <div class="container">
    <div class="card">
      <h1>Welcome to the CCNA Beta Test Program</h1>

      <h2>What do you get?</h2>
      <ul>
        <li class="spaced"><strong>FREE</strong> access to the Cisco CCNA 2025 course and labs for the duration of the beta testing period.</li>
        <li>You maintain your member subscription if you have one along with access to a handful of other freebie courses.</li>
      </ul>

      <h2>What are we asking in return?</h2>
      <ul>
        <li class="spaced">We ask that you <strong><em>actively participate</em></strong> in our beta program for the duration of your free access.</li>
<li>
  Check out the expectations for participants in our 
  <router-link to="/reviewer-guidelines" class="link">Reviewer Guidelines</router-link> 
  for more details.
</li>
      </ul>

      <router-link to="/signup" class="button">Sign Up for Beta Access</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.card {
  background-color: #171723;
  border-radius: 12px;
  padding: 30px;
  max-width: 900px;
  width: 100%;
  color: #fff;
  line-height: 1.8;
}

h1 {
  color: #CA9F43;
  margin-top: 0;
  font-weight: bold;
  font-size: 28px;
  text-align: left;
}

h2 {
  color: #CA9F43;
  margin-top: 40px;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 12px;
}

ul {
  font-size: 16px;
  margin-bottom: 16px;
  padding-left: 20px;
}

li.spaced {
  margin-bottom: 32px;
}

a.button {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  color: #000 !important;
  background-color: #CA9F43;
  border-radius: 48px;
  padding: 12px 35px;
  text-decoration: none !important;
  margin-top: 20px;
  width: fit-content;
}

a.link {
  color: #CA9F43 !important;
  font-weight: bold;
  text-decoration: none !important;
}

@media(max-width: 768px) {
  .card {
    padding: 20px; 
    max-width: 100%;
  }
  .container {
    padding: 20px;
  }
}
</style>

